import { useSelector } from "react-redux";

const Table = ({
    elements: { parentDiv = {}, thead = {}, tbody = {}, tr = {}, th = {}, td = {} },
    data,
    tableHeads,
    id
}) => {
    return (
        <div className={parentDiv?.className}>
            <div className={`flex w-full ${thead?.className}`}>
                {tableHeads?.map((thValue, index) => {
                    return (
                        <>
                            <div
                                className={`flex-1 flex justify-center  ${th?.className}`}
                                key={index}>
                                {thValue}
                            </div>
                        </>
                    );
                })}
            </div>
            <div className={tbody?.className}>
                {data?.map((tbRow) => {
                    let tbArray = Object.values(tbRow);
                    return (
                        <>
                            <div key={tbRow[id]} className={`flex ${tr?.className}`}>
                                {tbArray?.map((tdValue) => {
                                    return (
                                        <div
                                            className={`flex-1 flex justify-center ${td?.className}`}>
                                            {String(tdValue)}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    );
                })}
            </div>
        </div>
    );
};

export default Table;
